<template>
  <!-- saved from url=(0043)http://127.0.0.1:5503/certificate/cert2.htm -->
  <head><meta http-equiv="Content-Type" content="text/html; charset=UTF-16LE">
    <link rel="stylesheet" type="text/css" href="./cert2_files/style.css">


  </head>

  <link href="https://fonts.googleapis.com/css2?family=Norican&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,900;1,100;1,200;1,500;1,600&family=Norican&display=swap" rel="stylesheet">

  <!-- <link href="https://fonts.googleapis.com/css?family=Libre+Baskerville:400,400i,700|Open+Sans:300,400,600,700&display=swap" rel="stylesheet"> -->
  <link href="https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css?family=Aldrich|Fira+Sans:200,300,400,500,700,800,900|Norican&display=swap&subset=cyrillic" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,500;0,600;0,700;1,400;1,562;1,600&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Raleway:wght@300;600;700;800;900&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css?family=Share+Tech+Mono&display=swap" rel="stylesheet">

  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Amiri:ital,wght@0,400;0,700;1,400;1,700&family=Fondamento:ital@0;1&display=swap" rel="stylesheet">

  <body data-new-gr-c-s-check-loaded="14.980.0" style=" margin: 0px !important; ">
  <div class="page-container" style="
    width: 8.268in;
    height: 11.693in;
    background: #fffcfc;
    position: relative;
    margin: 0px;
    padding: 0px;
">
    <img style="position:absolute;top: 0.3in;left: 0.3in;width: 7.668in;height: 11.093in;" src="./cert2_files/ci_1.png">
    <img style="position:absolute;top: 0.17in;left: 0.17in;width: 7.928in;height: 11.353in;" src="./cert2_files/ci_2.png">
    <img style="position:absolute;top: 0.26in;left: 0.26in;width: 7.748in;height: 11.173in;" :src="bgLink">
    <img style="position:absolute;top: 0.65in;right: 0.45in;width:0.18in;height:0.18in;" src="./cert2_files/ci_5.png">
    <div style="position:absolute;top: 2.79in;left: 0in;width: 100%;line-height:0.96in;text-align: center;">
    <span style="font-style:normal;font-weight:normal;font-size: 30px;font-family: 'Montserrat', sans-serif;color:#212529;font-weight: 800; text-transform: uppercase;">
        County Government {{county.countyName}}
    </span>
    </div>
    <div style="position:absolute;top: 3.4in;/* left:5.19in; */width: 100%;line-height:0.56in;text-align: center; text-transform: uppercase; font-family: 'Montserrat', sans-serif;"><span style="font-style:normal;font-weight:bold;font-size: 18px;color:#212529;">Land, Physical Planning, Housing and Urban Development</span><span style="font-style:normal;font-weight:bold;font-size:30pt;font-family:Libre Baskerville;color:#212529"> </span><br></div>



    <div style="position:absolute;top: 4.0in;left: 0in;width: 100%;line-height:0.96in;text-align: center;"><span style="font-style:normal;font-weight:normal;font-size: 45px;font-family:Norican;color:#212529;">Construction Permit</span><span style="font-style:normal;font-weight:normal;font-size:45pt;font-family:Norican;color:#212529"> </span><br></div>
    <div style="position:absolute;top: 5.06in;left: 0.4in;width: 7.468in;height: auto;text-align: center;right: 0.4in;"><span style="font-style:normal;font-weight:normal;font-size: 15px;font-family:Fira Sans;color:#212529;">I hereby certify that the construction permit application for <strong>{{application.owner_full_names}} </strong> of ID Number <strong>{{application.owner_id_number}}</strong> has been <strong>approved</strong> to be undertaken at plot Number <strong>{{application.plot_number}}</strong> having met all the requirements.</span><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br></div>

    <div style="position:absolute;top: 6.56in;left: 0.45in;width: auto;text-align: left;">
      <span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;">Architect: </span>
      <span style="font-style:normal;font-weight:bold;font-size: 12pt;font-family:Fira Sans;color:#212529;">{{application.professional_name}}</span>
      <span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span>
      <br>
      <span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;">Plot No:</span>
      <span style="font-style:normal;font-weight:bold;font-size: 12pt;font-family:Fira Sans;color:#212529;">{{application.plot_number}}</span>
      <span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br>
      <span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;">Sub County </span>
      <span style="font-style:normal;font-weight:bold;font-size: 12pt;font-family:Fira Sans;color:#212529;">{{application.subCountyName}}</span>
      <span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br>
      <span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;">Ward: </span>
      <span style="font-style:normal;font-weight:bold;font-size: 12pt;font-family:Fira Sans;color:#212529;">{{application.wardName}}</span>
      <span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br>
    </div>


    <div style="position:absolute;top: 8.1in;left: 0.45in;width: auto;/* line-height:0.33in; */"><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Fira Sans;color:#212529">Sign:</span><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br></div>
    <img style="position:absolute;top: 7.56in;left: 1.03in;width:1.13in;height:0.89in;" :src="signature">
    <div style="position:absolute;top: 8.48in;left: 0.45in;width: auto;height: auto;"><span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;">County Officer (Land, Physical Plannning & Housing)</span><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br><span style="font-style:normal;font-weight:normal;font-size: 12pt;font-family:Fira Sans;color:#212529;font-weight: bold;">Date: {{formattedDate(application.updated_at)}}</span><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br></div>
    <img style="position:absolute;bottom: 1.2in;right: 0.45in;width: auto;height: 1.5in; transform: rotate(12deg);" :src="sealConstruction">
    <img style="position:absolute;bottom: 1in;left: 0.45in;width: auto;height: 0.6in;" :src="poweredByLogo">
    <div class="logo-container" style="
    width: 100%;
    height: auto;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 1.5in;
">
      <img :src="county.logo" style="
    height: 1.4in;
">
    </div>
    <div style="position:absolute;top: 0.4in;right: 0.4in;width: 100%;/* line-height:0.27in; */text-align: right;"><span style="font-style:normal;font-weight:normal;font-size: 13pt;font-family:Aldrich;color:#000000;">Serial NO. {{application.application_number}}</span><span style="font-style:normal;font-weight:normal;font-size:15pt;font-family:Aldrich;color:#000000"> </span><br></div>
    <img style="position:absolute;top: 0.4in;left: 0.4in;height: 1in;width: 1in;" :src="link">
    <div style="position:absolute;bottom: 0.75in;left: 0.45in;width: auto;line-height:0.15in;"><span style="font-style:normal;font-weight: 400;font-size: 12px;font-family:Fira Sans;color:#212529;"><strong>NB:</strong> This Permit does not exempt the holder of the certificate from obeying existing laws.</span><span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br></div>
    <div style="position:absolute;bottom: 0.84in;right: 0.45in;width: auto;text-align: right;"><span style="font-style:normal;font-weight: 500;font-size: 15px;font-family:Fira Sans;color: #043d75;background: #0358c147;padding: 6px;margin-bottom: 11px;border-radius: 2px;">APPROVED</span><span style="font-style:normal;font-weight:bold;font-size:15pt;font-family:Fira Sans;color:#212529"> </span><br></div>
    <img style="position:absolute;bottom: 0.67in;left: 0.45in;width: 7.368in;height:0.01in;right: 0.45in;" src="./cert2_files/ci_11.png">
    <div style="position:absolute;bottom: 0.4in;left: 0.45in;width: 7.368in;right: 0.45in;height: auto;"><span style="font-style:normal;font-weight:bold;font-size: 8pt;font-family:Fira Sans;color:#212529;">County Government of {{county.countyName}}, </span><span style="font-style:normal;font-weight:normal;font-size: 8pt;font-family:Fira Sans;color:#212529;">, | {{county.address}}</span><span style="font-style:normal;font-weight:normal;font-size: 8pt;font-family:Fira Sans;color:#212529;"> </span><br></div>
    <div style="position:absolute;bottom: 0.4in;right: 0.45in;width:5.21in;height: auto;text-align: right;"><span style="font-style:normal;font-weight:bold;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">Contacts</span>
      <span style="font-style:normal;font-weight:bold;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">, T:</span>
      <span style="font-style:normal;font-weight:normal;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">Toll free: {{county.contact}}
    </span>
      <span style="font-style:normal;font-weight:bold;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">T:</span>
      <span style="font-style:normal;font-weight:bold;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">E:</span>
      <span style="font-style:normal;font-weight:normal;font-size: 8pt;font-family:Fira Sans;color:#212529;text-align: right;">{{county.email}}</span>
      <br>
    </div>
  </div>
  </body>
</template>

<script>

/* eslint-disable */

import {execute, liquor, base, trade, biller, state_logo, county_logo, econstruction} from "@/api";
import numWords from 'num-words';
import moment from "moment";
export default {
  name: "ConstructionPermit",
  data() {
    return {
      bgLink: base+'/logo/bg-image-construction.jpg',
      sealConstruction: base+'/logo/seal-construction.png',
      poweredByLogo: base+'/logo/powered-by.png',
      signature: base+'/logo/signature-construction.png',

      application: {
          id: null,
          application_number: null,
          development_type: null,
          project_title: null,
          project_value: null,
          project_description: null,
          professional_id: null,
          plot_number: null,
          upn_number: null,
          plot_size: null,
          land_value: null,
          annual_land_rate: null,
          current_balance: null,
          land_type: null,
          land_use: null,
          owner_full_names: null,
          owner_id_number: null,
          owner_phone_number: null,
          owner_email: null,
          owner_kra_pin: null,
          owner_address: null,
          subCountyName: null,
          wardName: null,
          subCountyID: null,
          wardID: null,
          status: null,
          created_by: null,
          created_by_id: null,
          created_at: null,
          updated_at: null,
          billNo: null,
          paymentStatus: null,
          detailAmount: null,
          receiptAmount: null,
          billBalance: null,
          billNoFinal: null,
          detailAmountFinal: null,
          receiptAmountFinal: null,
          billBalanceFinal: null,
          finalPayment: null,
          printPermit: null,
          professional_name: null,
          professional_phone: null,
          professional_email: null,
          professional_type: null,
          certificate_number: null

      },
      link:'',
      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline:null,
        smsusername: null,
        smspassword:null,
        contact: null,
        center: null,
        address:null,
        email: null,
        headline: null,
        tagline2:null,
        ussd: null,
        logo:null,
        bank: null,
        powered: null,
        stateLogo: null,
        seal: null,
        signature: null,
        QRLink:null,
        sealLiquor:null,
        signatureLiquor:null
      },
    };
  },
  computed: {
    year() {
      let date = new Date(this.permit.startDate);
      let year = date.getFullYear();
      return year;
    }},
  mounted() {

    // Get the hash from the URL
    const hash = window.location.hash;

    const numberFromURL = hash.split('/')[3];

    // If number is passed in the URL
    if (numberFromURL) {
      console.log('Number from URL:', numberFromURL);
      this.printConstructionPermit(numberFromURL);
    } else {
      // Number is not passed in the URL, check localStorage
      let params = {};
      try {
        params = JSON.parse(localStorage.getItem('params'));
        console.log('Number from localStorage:', params.applicationId);
        this.printConstructionPermit(params.applicationId);
      } catch (error) {
        console.error('Error parsing localStorage:', error);
      }
    }


  },
  methods: {

    state_logo() {
      return state_logo
    },
    county_logo() {
      return county_logo
    },

    menuAccess(){

      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "printConstructionPermit");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // alert(res.data.message);
          })
          .catch((e) => {
            // alert(e.message);
          });

    },
    currentDate(){
      let date = new Date();
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let suffix = hour >= 12 ? "PM" : "AM";
      hour = hour % 12 || 12;
      day = day < 10 ? "0" + day : day;
      month = month < 10 ? "0" + (month + 1) : month + 1;
      minute = minute < 10 ? "0" + minute : minute;
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let monthName = months[month - 1];
      let formattedDate = `${day} ${monthName} ${year} ${hour}:${minute} ${suffix}`;
      return formattedDate;
    },

    formattedDate(date2) {
      let date = new Date(date2);
      let day = date.getDate();
      let month = date.getMonth();
      let year = date.getFullYear();
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let monthName = months[month];
      return `${day} ${monthName} ${year}`;
    },

    numberWords(num){
      return numWords(num)
    },

    showDate() {
      const dateObj = new Date();
      const currentDate =
          dateObj.getDate() +
          "/" +
          dateObj.getMonth() +
          "/" +
          dateObj.getFullYear();
      return currentDate;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },


    printConstructionPermit(applicationId) {
      const data = new FormData();
      data.append("function", "printConstructionPermit");
      data.append("applicationId", applicationId);

      execute(data,econstruction)
          .then((res) => {
            if (res.data.success) {
              this.application = res.data.data.application;
              this.county = res.data.data.county

              this.link =`${this.county.QRLink} applicationId: ${applicationId} | ${this.application.application_number}`;
            } else {
              alert(res.data.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },
    formattedTime(time) {
      return moment(time).format('hh:mm A')
    },
    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },
    mailTradePermit(){
      const data = new FormData();
      data.append("function", "mailTradePermit");
      data.append("businessID", this.$route.params['data']);

      execute(data,trade)
          .then((res) => {
            alert(res.data.message);
          })
          .catch((e) => {
            alert(e.message);
          });

    }

  },
}
</script>

<style scoped>
body{
  margin: 0px !important;
  background: repeating-linear-gradient(45deg, #039840, #039840 10px, #00421b 10px, #00421b 20px);
  background-repeat: no-repeat;
  min-height: 100vh;
  padding: 15px;
}

@media print{
  body{
    background-color: white !important;
    background:white !important;
    padding: 0px !important;
  }
}
</style>

<style id="stndz-style">

</style>